import { render, staticRenderFns } from "./lunTai.vue?vue&type=template&id=d9c407f8&scoped=true&"
import script from "./lunTai.vue?vue&type=script&lang=js&"
export * from "./lunTai.vue?vue&type=script&lang=js&"
import style0 from "./lunTai.vue?vue&type=style&index=0&id=d9c407f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c407f8",
  null
  
)

export default component.exports